// extracted by mini-css-extract-plugin
module.exports = {"title":"FormHeading_title_3LpO2","badge":"FormHeading_badge_2ajtR","text":"FormHeading_text_2lUqC","line":"FormHeading_line_3gfB6"};